<template>
  <v-container fluid class="d-sm-none">
    <v-row>
      <v-col>
        <search-bar />
      </v-col>
    </v-row>
  </v-container>
</template>
